import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageNotFound.css';

export const PageNotFound = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate("/")
  };

  return (
    <div className="not-found">
        <h1>404 Page Not Found!</h1>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <button onClick={handleReturn}>Go Back</button>
    </div>
  )
};